"use strict";

exports.__esModule = true;
exports.IFrameElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Device = require("../../Device");
var _Theme = require("../../Theme");
var _Time = require("../../Time");
var _common = require("../common");
var _whenModern = require("../../Theme/UiDesign/whenModern");
var _dec, _dec2, _class;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var StyledIFrame = _styledComponents["default"].iframe.withConfig({
  displayName: "IFrameElement__StyledIFrame",
  componentId: "sc-l9zy4-0"
})(["", ""], (0, _whenModern.whenModern)((0, _styledComponents.css)(["border:0;border-radius:11px;background:#ffffff;box-shadow:", ";"], (0, _Theme.val)("CardShadow")), (0, _styledComponents.css)(["border:solid 1px ", ";"], (0, _Theme.val)("borderColor"))));

/**
 * Displays a label for a section.
 */
var IFrameElement = exports.IFrameElement = (_dec = _Device.DeviceContext.withContext, _dec2 = _Time.ReportingPeriodContext.withContext, _dec(_class = _dec2(_class = /*#__PURE__*/function (_Component) {
  function IFrameElement() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(IFrameElement, _Component);
  var _proto = IFrameElement.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      device = _this$props.device,
      reportingPeriod = _this$props.reportingPeriod,
      _this$props$urlTempla = _this$props.urlTemplate,
      urlTemplate = _this$props$urlTempla === void 0 ? "about:blank" : _this$props$urlTempla;
    var url = urlTemplate;
    if (device != null) {
      url = url.replace(/\{device_id\}/g, device.uuid);
      url = url.replace(/\{device_name\}/g, device.name);
    }
    if (reportingPeriod != null) {
      url = url.replace(/\{start_date\}/g, new Date(reportingPeriod.interval.startMillis).toISOString());
      url = url.replace(/\{end_date\}/g, new Date(reportingPeriod.interval.endMillis).toISOString());
    }
    return /*#__PURE__*/_react["default"].createElement(StyledIFrame, {
      style: (0, _common.getWidgetPositionProps)(this.props),
      allow: "autoplay",
      title: "IFrameElement",
      src: url
    });
  };
  return IFrameElement;
}(_react.Component)) || _class) || _class);